/**
 * Layout of the property panel, shared by every panel so they line up and space alike.
 *
 * A panel is one accordion (PANEL_ACCORDION_SX) holding its fields in a column
 * (FIELDS_SPACING, with FIELDS_PADDING_BOTTOM below). Sub-sections (constellation, load carrier,
 * vehicle settings) are accordions inside that column, their own fields spaced by FIELDS_SPACING.
 * An inner section after the fields (e.g. the rack spec) is preceded by a plain Divider.
 */

/** The top-level accordion of a panel: its horizontal padding */
export const PANEL_ACCORDION_SX = { px: 2 };

/** Space between the panels */
export const PANELS_SPACING = 1;

/** Space between the fields of a panel or sub-section */
export const FIELDS_SPACING = 1;

/** Space below a panel's fields, before the panel ends or an inner section starts */
export const FIELDS_PADDING_BOTTOM = 2;
